<template>
  <el-col :span="24" :style="{height: height}">
    <div :class="className" :style="{height:height,width:width}" />
  </el-col>
</template>
<script>
  import echarts from 'echarts'
  import 'echarts/map/js/china'
  require('echarts/theme/macarons') // echarts theme
  import mapDataConfig from '../data/map.js'
  import {
    debounce
  } from '../../utils/helper.js'
  import lodash from 'lodash'
  // import Heatmap from "heatmap.js";
  export default {
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '500px'
      },
      show:{
              type:Boolean,
              default:true
            },
      // 图标配置
      chartConfig: {
        type: Object,
        default: null
      },
      title: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        chart: null,
        mapDataConfigModel: mapDataConfig,
        chartConfigModel: {},
        sidebarElm: null,
        defaultConfig: {
          title: {
            text: this.title,
            left: 'center',
            show: false
          },
          tooltip: {
            trigger: 'item',
            formatter: function(prames) {
              var value = prames.value;
              if (!value) {
                value = 0;
              }
              if (typeof(value) == 'number') {
                value = value;
              } else {
                value = value[2];
              }
              return prames.name + ':' + value
            }
          },
          geo: {
            map: 'china',
            label: {
              emphasis: {
                show: false
              }
            },
            roam: true,
            itemStyle: {
              normal: {
                areaColor: '#ff0000',
                borderColor: '#404a59'
              },
              emphasis: {
                areaColor: '#00ff00'
              }
            }
          },
          series: [{
            type: 'map',
            mapType: 'china',
            geoIndex:0,
            showLegendSymbol: false, // 存在legend时显示
            data: []
          }]
        }
      }
    },
    watch: {
      // 防止表格预置数据不成功，涉及生命周期问题
      chartConfig: {
        handler(newValue, oldValue) {
          this.chartConfigModel = lodash.cloneDeep(newValue)
          let _config = lodash.cloneDeep(this.defaultConfig)
          lodash.merge(_config, this.chartConfigModel)
          this.chartConfigModel = _config
          this.setOptions(true)
        },
        deep: true
      },
      widthHeight:{
        handler(newValue,oldValue){
          console.info("widthHeight变化===width"+newValue.width+"=====height="+newValue.height)
          this.__resizeHandler()
        },
        deep:true
      },
       show:{
              handler(newValue,oldValue){
                this.__resizeHandler()
              },
              deep:true
            }
    },
    mounted() {
      this.chartConfigModel = lodash.cloneDeep(this.chartConfig)
      let _config = lodash.cloneDeep(this.defaultConfig)


      lodash.merge(_config, this.chartConfigModel)
      this.chartConfigModel = _config
      this.initChart()
     
      	this.__resizeHandler = debounce(() => {
      		if (this.chart) {
      			this.chart.resize()
      		}
      	}, 100)
      	window.addEventListener('resize', this.__resizeHandler)
      
    },
    beforeDestroy() {
    	if (!this.chart) {
    		return
    	}
    	
    	window.removeEventListener('resize', this.__resizeHandler)
    	
    
    	this.sidebarElm && this.sidebarElm.removeEventListener('transitionend', this.sidebarResizeHandler)
    
    	this.chart.dispose()
    	this.chart = null
    },
    computed:{
      widthHeight(){
        return {
          width:this.width,
          height:this.height
        }
      }
    },
    methods: {
      initChart() {
        this.chart = echarts.init(this.$el, 'macarons')
        this.setOptions(false)
      },
      convertData(data) {
        var res = []
        for (var i = 0; i < data.length; i++) {
          var geoCoord = this.geoCoordMap[data[i].name]
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            })
          }
        }
        return res
      },
      setOptions(notMerge) {
        if (this.mapDataConfigModel.data) {
          for (let i = 0; i < this.mapDataConfigModel.data.length; i++) {
            echarts.registerMap(this.mapDataConfigModel.data[i].type, this.mapDataConfigModel.data[i].data);
          }
        }
        try {
          this.chart.setOption(this.chartConfigModel, notMerge)
        } catch (e) {}
        this.chart.on('finished', function() {
          try {
            var _charts = document.getElementsByTagName('canvas')
            for (var i = 0; i < _charts.length; i++) {
              _charts[i].style.cursor = 'default'
            }
          } catch (e) {

          }
        })
        this.chart.resize()
      }
    }
  }
</script>

<style>
  .mapDiv {
    width: 50%;
    height: 50%;
    padding: 10px;
    box-sizing: border-box;
  }

  .mapCon .title {
    position: absolute;
    z-index: 1;
    height: 34px;
    line-height: 34px;
    font-size: 18px;
    font-weight: 700;
    padding-left: 14px;
    border-left: 6px solid #abd3d5;
    box-sizing: border-box;
  }

  .mapCon,
  .mapChart {
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/MapChart.vue